export function getScenarios(state) {
    return state.items;
}
export function isFetching(state) {
    return state.fetching;
}
export function getSelectedScenario(state) {
    return state.selected;
}
export function getSelectedScenarioName(state) {
    return state.scenarioName;
}
export function getSelectedWorkspaceName(state) {
    return state.workspaceName;
}
export function getWorkspacesByScenario(state) {
    const scenarios = state.items || [];
    const mappedWks2Scen = scenarios.reduce((acc, scenario) => {
        acc[scenario.name] = scenario.workspaces.map(wks => wks.name);
        return acc;
    }, {});
    return mappedWks2Scen;
}
export const selectors = {
    isFetching,
    getScenarios,
    getSelectedScenario,
    getSelectedScenarioName,
    getSelectedWorkspaceName,
    getWorkspacesByScenario
};
//# sourceMappingURL=selectors.js.map